import React from 'react';
import Page from '../../layout/Page';
import MobileProducts from '../mobile/Products';
import FulfillableProducts from '../fulfillment/Products';
import KioskItems from '../settings/KioskItems';
import WashBundles from '../codes/WashBundles';
import WashClub from '../washClub/Management';
import Awards from '../expressPass/Awards';

const Index = ({ ...props }) => {

    return (
        <Page
            title='Products'
            icon='coins'
            tabs
        >
            <KioskItems tab='Kiosk Items' />
            <WashClub tab='Wash Clubs' />
            <Awards tab='ExpressPass' />
            <MobileProducts tab='Mobile' />
            <FulfillableProducts tab='Fulfillment' />
            <WashBundles tab='Bundle Codes' />
        </Page>
    );
}

export default Index;